import {
  CHART_ICON,
  CHAT_SMILE_ICON,
  DATABASE_ICON,
  GRID_ICON,
  MENU_ICON_FLOW,
  MENU_ICON_MICROSHIP,
  SETTING_LIST_ICON,
  TEAM_ICON,
  WALLET_ICON,
} from "@/components/atoms/IconSet";
import IMAGE_01 from "@/public/images/home/ai_card_01.webp";
import IMAGE_02 from "@/public/images/home/ai_card_02.webp";
import IMAGE_03 from "@/public/images/home/ai_card_03.webp";
import IMAGE_04 from "@/public/images/home/ai_card_04.webp";
import IMAGE_05 from "@/public/images/home/ai_card_05.webp";
import IMAGE_06 from "@/public/images/home/ai_card_06.webp";
import IMAGE_07 from "@/public/images/home/ai_card_07.webp";
import IMAGE_08 from "@/public/images/home/ai_card_08.webp";
import IMAGE_09 from "@/public/images/home/ai_card_09.webp";
import { StaticImageData } from "next/image";
import { ReactElement } from "react";

export interface ISlideContent {
  id: string;
  title: string;
  description: string;
  image: StaticImageData;
  icon?: ReactElement;
  iconActive?: ReactElement;
}
export const SLIDER_CONTENT: ISlideContent[] = [
  {
    id: "slide-1",
    title: "AI Agent Marketplace: Unmatched Flexibility and Visibility",
    description:
      "<ul><li>Effortlessly showcase and build AI agents using diverse, state-of-the-art models.</li><li>Schedule AI agents for efficient automation and enhanced productivity.</li><li>Amplify visibility and engagement through strategically showcased AI agents on the platform feed page.</li></ul>",
    image: IMAGE_01,
    icon: MENU_ICON_MICROSHIP("#0F1324"),
    iconActive: MENU_ICON_MICROSHIP("#9D89FC", "1"),
  },
  {
    id: "slide-2",
    title: "Seamless Payment Integration with NAKA Wallet",
    description:
      "<ul><li>Ensure secure and seamless cryptocurrency transactions via NAKA Wallet integration.</li></ul>",
    image: IMAGE_02,
    icon: WALLET_ICON("#0F1324"),
    iconActive: WALLET_ICON("#9D89FC", "1"),
  },
  {
    id: "slide-3",
    title: "Empower Team Collaboration",
    description:
      "<ul><li>Foster unparalleled innovation through seamless collaboration by inviting members to contribute to AI agent development.</li><li>Detailed edit logs and versioning for efficient iteration management and teamwork fortification.</li></ul>",
    image: IMAGE_03,
    icon: TEAM_ICON("#0F1324"),
    iconActive: TEAM_ICON("#9D89FC", "1"),
  },
  {
    id: "slide-4",
    title: "AI Agent Workflow Automation: Streamlined Efficiency",
    description:
      "<ul><li>Create dynamic workflows by connecting multiple AI agents for enhanced functionality and automation.</li><li>Maximize efficiency by integrating third-party services to streamline processes.</li></ul>",
    image: IMAGE_04,
    icon: MENU_ICON_FLOW("#0F1324"),
    iconActive: MENU_ICON_FLOW("#9D89FC", "1"),
  },
  {
    id: "slide-5",
    title: "AI-Powered Chatbots with Deep Learning: Conversational Excellence",
    description:
      "<ul><li>Leverage advanced AI deep learning models such as Retrieval-Augmented Generation (RAG) to craft intelligent chatbots.</li><li>Immerse users in conversational experiences with cutting-edge Large Language Models (LLMs) via Open API integration.</li></ul>",
    image: IMAGE_05,
    icon: CHAT_SMILE_ICON("#0F1324"),
    iconActive: CHAT_SMILE_ICON("#9D89FC", "1"),
  },
  {
    id: "slide-6",
    title:
      "Data Integration for Enhanced AI Performance: Maximizing Capabilities",
    description:
      "<ul><li>Seamlessly upload documents in various formats to feed data to RAG, whether it's PDFs, DOCX, or Excel files.</li><li>Elevate AI performance through real-time data access via seamless connection to external databases.</li></ul>",
    image: IMAGE_06,
    icon: DATABASE_ICON("#0F1324"),
    iconActive: DATABASE_ICON("#9D89FC", "1"),
  },
  {
    id: "slide-7",
    title: "AI Agent Customization and Personalization: Tailoring Solutions",
    description:
      "<ul><li>Craft custom workflows catering to specific business requirements and dynamic use cases.</li><li>Adaptive learning and configurable parameters ensure personalized AI behavior for tailored responses.</li></ul>",
    image: IMAGE_07,
    icon: SETTING_LIST_ICON("#0F1324"),
    iconActive: SETTING_LIST_ICON("#9D89FC", "1"),
  },
  {
    id: "slide-8",
    title:
      "AI Agent Monitoring and Actionable Insights: Informed Decision-Making",
    description:
      "<ul><li>Draw actionable insights from real-time monitoring dashboards and performance metrics to drive business decisions.</li><li>Stay informed with valuable insights powered by usage analytics and automated alerts for system optimizations.</li></ul>",
    image: IMAGE_08,
    icon: CHART_ICON("#0F1324"),
    iconActive: CHART_ICON("#9D89FC", "1"),
  },
  {
    id: "slide-9",
    title: "Multi-Model AI Deployment: Unprecedented Performance Comparison",
    description:
      "<ul><li>Extend AI capabilities with the ability to incorporate and compare the performance of multiple AI models within a single agent.</li><li>Seamlessly switch between different models based on use cases, leveraging AI model benchmarking for unmatched scalability and performance.</li></ul>",
    image: IMAGE_09,
    icon: GRID_ICON("#0F1324"),
    iconActive: GRID_ICON("#9D89FC", "1"),
  },
];

// Text
export const TEXT_MARQUEE = [
  { id: "automate", text: "Automate" },
  { id: "optimize", text: "Optimize" },
  { id: "analyze", text: "Analyze" },
  { id: "evolve", text: "Evolve" },
];
